export {
  fetchMyPrivateFolderStorage,
  fetchWorkspacePrivateFolderStorage,
  getMyPrivateFolderStorageCacheKey,
  getWorkspacePrivateFolderStorageCacheKey,
  type PrivateFolderStorageGroupLimit,
  type PrivateFolderStorageUsage,
  type PrivateFolderStorageUserOverride,
  resetWorkspacePrivateFolderStorageGroupLimit,
  resetWorkspacePrivateFolderStorageLimit,
  updateWorkspacePrivateFolderStorageDefaultLimit,
  updateWorkspacePrivateFolderStorageGroupLimit,
  updateWorkspacePrivateFolderStorageLimit,
  type WorkspacePrivateStoragePolicy,
} from './private-folder-storage';
export { WorkspaceQuotaService } from './services/quota';
export { QuotaCheck } from './views/quota-check';
export { useUpgradePrompt } from './views/upgrade-prompt';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { GlobalState } from '../storage';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { WorkspaceQuota } from './entities/quota';
import { WorkspaceQuotaService } from './services/quota';
import { WorkspaceQuotaStore } from './stores/quota';

export function configureQuotaModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceQuotaService)
    .store(WorkspaceQuotaStore, [WorkspaceServerService, GlobalState])
    .entity(WorkspaceQuota, [WorkspaceService, WorkspaceQuotaStore]);
}
